export enum CustomerCommand {
  FullfillInfo = 0,
  Purchase,
  ChangePassword,
  ConnectionList,
  ServiceList,
  RenewRequest,
  Ip,
  TechnicalProblem,
  CollectRequest,
  ChangeService,
  BuyTraffic,
  TrafficList,
  AdvancePurchase,
  TicketRegistration,
  TicketList,
  CustomerInfo,
  SpeedTest,
  RequestStaticIp,
  ExtendStaticIp,
  RequestJitterAnalyze,
}

export const CustomerCommandMetadata = {
  //   [CustomerCommand.FullfillInfo]: {
  //       description: "ویرایش اطلاعات تکمیلی",
  //       helpText: "رفتن به صفحه ی ویرایش و تصحیح و تکمیل اطلاعات تکمیلی خط اینترنت پرسرعت جاری.",
  //       path:""
  //   },
  [CustomerCommand.Purchase]: {
    description: "خرید سرویس",
    helpText: "رفتن به صفحه ی خرید سرویس برای خط اینترنت پرسرعت جاری.",
    path: "purchase/packages",
  },
  //   [CustomerCommand.ChangePassword]: {
  //       description: "تغییر گذرواژه",
  //       helpText: "رفتن به صفحه ی تغییر گذرواژه سرویس اینترنت پرسرعت، که نیازمند تغییر تنظیمات مودم نیز خواهد بود.",
  //       path:""
  //   },
  //   [CustomerCommand.ConnectionList]: {
  //       description: "ریز کارکرد",
  //       helpText: "رفتن به صفحه ی مشاهده ریز کارکرد و اتصالات خط جاری اینترنت پرسرعت.",
  //       path:""
  //   },
  //   [CustomerCommand.ServiceList]: {
  //       description: "لیست سرویس ها",
  //       helpText: "رفتن به صفحه ی مشاهده لیست سرویس های خریداری و فعال شده برای خط جاری اینترنت پرسرعت.",
  //       path:""
  //   },
  //   [CustomerCommand.RenewRequest]: {
  //       description: "درخواست مجدد راه اندازی خط",
  //       helpText: "ارسال درخواست جهت راه اندازی مجدد اینترنت پرسرعت بر روی خط جاری.",
  //       path:""
  //   },
  [CustomerCommand.RequestStaticIp]: {
    description: "درخواست IP ثابت",
    helpText: "ارسال درخواست دریافت IP ثابت برای خط جاری.",
    path: "purchase/ip",
  },
  [CustomerCommand.ExtendStaticIp]: {
    description: "درخواست تمدید IP ثابت",
    helpText: "ارسال درخواست دریافت IP ثابت برای خط جاری.",
    path: "purchase/ip",
  },
  //   [CustomerCommand.TechnicalProblem]: {
  //       description: "اعلام مشکل فنی",
  //       helpText: "اعلام مشکل و ایراد فنی مشاهده شده برای خط جاری.",
  //       path:""
  //   },
  //   [CustomerCommand.CollectRequest]: {
  //       description: "جمع آوری",
  //       helpText: "ارسال درخواست جمع آوری خط و قطع ارتباط اینترنت پرسرعت.",
  //       path:""
  //   },
  //   [CustomerCommand.ChangeService]: {
  //       description: "تغییر سرویس جاری",
  //       helpText: "ارسال درخواست تغییر سرویس و تعرفه اینترنت پرسرعت.",
  //       path:""
  //   },
  [CustomerCommand.BuyTraffic]: {
    description: "خرید ترافیک",
    helpText: "خرید ترافیک/بسته برای تعرفه اینترنت پرسرعت.",
    path: "purchase/packages",
  },
  //   [CustomerCommand.TrafficList]: {
  //       description: "لیست بسته های افزایشی",
  //       helpText: "رفتن به صفحه ی مشاهده لیست بسته های افزایشی دریافت شده برای خط جاری اینترنت پرسرعت.",
  //       path:""
  //   },
  [CustomerCommand.AdvancePurchase]: {
    description: "خرید سرویس",
    helpText: "پیش خرید سرویس بعدی که با اتمام سرویس جاری فعال خواهد شد.",
    path: "purchase/service",
  },
  //   [CustomerCommand.TicketRegistration]: {
  //       description: "ثبت تیکت جدید",
  //       helpText: "ثبت تیکت جدید جهت اعلام مشکل یا ایراد یا پیگیری موضوع یا ارائه پیشنهاد یا انتقاد و ...",
  //       path:""
  //   },
  //   [CustomerCommand.TicketList]: {
  //       description: "پیگیری تیکت",
  //       helpText: "پیگیری و مشاهده وضعیت و نتیجه تیکت های ثبت شده قبلی",
  //       path:""
  //   },
  //   [CustomerCommand.CustomerInfo]: {
  //       description: "ویرایش اطلاعات مشترک",
  //       helpText: "تغییر اطلاعات هویتی مشتری که مسئولیت حقوقی مصرف اینترنت را دارد",
  //       path:""
  //   },
  //   [CustomerCommand.SpeedTest]: {
  //       description: "سنجش سرعت",
  //       helpText: "سنجش سرعت خط جاری و مشاهده تاریخچه تست های سابق",
  //       path:"/speedTest"
  //   },
  //   [CustomerCommand.RequestStaticIp]: {
  //       description: "درخواست Ip ثابت",
  //       helpText: "خرید IP ثابت و فعال شدن آن پس از بررسی توسط کارشناس و اختصاص IP به شما",
  //       path:""
  //   },
  //   [CustomerCommand.ExtendStaticIp]: {
  //       description: "تمدید Ip ثابت",
  //       helpText: "تمدید Ip ثابت خط",
  //       path:""
  //   },
  //   [CustomerCommand.RequestJitterAnalyze]: {
  //       description: "درخواست SLA",
  //       helpText: "درخواست شما ثبت خواهد شد و طی سه روز آتی بررسی خواهد شد.",
  //       path:""
  //   }
} as const;
